module.exports = __webpack_public_path__ + "img/docx.5e9f7af1.svg";